// extracted by mini-css-extract-plugin
export var activeTab = "bm_dS";
export var chartDescription = "bm_dP";
export var heading = "bm_dH";
export var legendTitle = "bm_dT";
export var summaryTile = "bm_dL";
export var summaryTileTitle = "bm_dM";
export var summaryTileValue = "bm_dN";
export var summaryTilesContainer = "bm_dJ";
export var summaryTilesRow = "bm_dK";
export var tabButton = "bm_dR";
export var tabContainer = "bm_dQ";
export var wrapper = "bm_bF";